"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifierReplacer = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../../container/ServiceIdentifiers");
const NodeFactory_1 = require("../../../node/NodeFactory");
let IdentifierReplacer = class IdentifierReplacer {
    constructor(identifierNamesGeneratorFactory, identifierNamesCacheStorage, options) {
        this.blockScopesMap = new WeakMap();
        this.options = options;
        this.identifierNamesCacheStorage = identifierNamesCacheStorage;
        this.identifierNamesGenerator = identifierNamesGeneratorFactory(options);
    }
    storeGlobalName(identifierNode, lexicalScopeNode) {
        var _a;
        const identifierName = identifierNode.name;
        if (this.isReservedName(identifierName)) {
            return;
        }
        const newIdentifierName = this.identifierNamesGenerator.generateForGlobalScope();
        const namesMap = (_a = this.blockScopesMap.get(lexicalScopeNode)) !== null && _a !== void 0 ? _a : new Map();
        namesMap.set(identifierName, newIdentifierName);
        this.blockScopesMap.set(lexicalScopeNode, namesMap);
        if (this.options.identifierNamesCache) {
            this.identifierNamesCacheStorage.set(identifierName, newIdentifierName);
        }
    }
    storeLocalName(identifierNode, lexicalScopeNode) {
        var _a;
        const identifierName = identifierNode.name;
        if (this.isReservedName(identifierName)) {
            return;
        }
        const newIdentifierName = this.identifierNamesGenerator.generateForLexicalScope(lexicalScopeNode);
        const namesMap = (_a = this.blockScopesMap.get(lexicalScopeNode)) !== null && _a !== void 0 ? _a : new Map();
        namesMap.set(identifierName, newIdentifierName);
        this.blockScopesMap.set(lexicalScopeNode, namesMap);
    }
    replace(identifierNode, lexicalScopeNode) {
        var _a, _b;
        const namesMap = (_a = this.blockScopesMap.get(lexicalScopeNode)) !== null && _a !== void 0 ? _a : null;
        if (!namesMap) {
            return identifierNode;
        }
        const identifierName = (_b = namesMap.get(identifierNode.name)) !== null && _b !== void 0 ? _b : null;
        if (!identifierName) {
            return identifierNode;
        }
        return NodeFactory_1.NodeFactory.identifierNode(identifierName);
    }
    preserveName(identifierNode) {
        this.identifierNamesGenerator.preserveName(identifierNode.name);
    }
    preserveNameForLexicalScope(identifierNode, lexicalScopeNode) {
        this.identifierNamesGenerator.preserveNameForLexicalScope(identifierNode.name, lexicalScopeNode);
    }
    isReservedName(name) {
        if (!this.options.reservedNames.length) {
            return false;
        }
        return this.options.reservedNames
            .some((reservedName) => {
            return new RegExp(reservedName, 'g').exec(name) !== null;
        });
    }
};
IdentifierReplacer = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IGlobalIdentifierNamesCacheStorage)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [Function, Object, Object])
], IdentifierReplacer);
exports.IdentifierReplacer = IdentifierReplacer;
